const css = `
@font-face {
  font-family: "Tomorrow";
  src: url("/fonts/Tomorrow-Light.ttf") format("truetype");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Tomorrow";
  src: url("/fonts/Tomorrow-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Tomorrow";
  src: url("/fonts/Tomorrow-SemiBold.ttf") format("truetype");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Tomorrow";
  src: url("/fonts/Tomorrow-Bold.ttf") format("truetype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
`;

const style = document.createElement("style");
style.textContent = css;
document.head.appendChild(style);
